import { takeEvery, put } from "redux-saga/effects";
import { ENDPOINT } from "../../../config/endpoints";
import { notifyError } from "../../../effects-bridge";
import {
  getLoyaltyDetails,
  getLoyaltyProviders,
  redeemPoints,
  redeemPointsSuccess,
  refundLoyaltyPoints,
  verifyLoyaltyOtp,
  externalOfferVerify,
  customerOfferList,
  unBlockExternalDiscount,
  sendCustomerConsentOtp,
  verifyCustomerConsentOtp,
  customerOptOut,
  getProgramDetails,
} from "../../slices/Loyalty";
import {
  commonPostData,
  customerOptOutSaga,
  unblockExternalPartnerDiscount,
  verifyExternalOffer,
  fetchProgramDetails,
  getLoyaltyDetailsData,
  getLoyaltyProvidersData,
  refundPoints,
  sendCustomerConsentOtpSaga,
  updateRedeemPointsData,
  verifyCustomerConsentOtpSaga,
  verifyOtpData,
} from "./shared";

export * from "./shared";

/* ── the one WEB-ONLY worker left: XenoModal's coupon list ─────────────────────── */

/**
 * The customer's partner coupons, for `components/XenoModal`.
 *
 * 🔴 Its callback is OPTIONAL and its catch reads `actions.payload?.callback?.(...)` as of
 * 2026-09-08, matching `shared.ts`. The catch used to read `actions.payload.data.callback` —
 * the `.data.` typo, a payload key that has never existed — so the error path threw instead of
 * reporting, and `takeEvery` would have carried that throw to the root and cancelled all twelve
 * of this file's watchers. Unreachable today (`commonPostData` swallows, and XenoModal passes a
 * callback); fixed because that is exactly how the identical pair in `getLoyaltyDetailsData`
 * sat dormant until a new caller omitted the callback. See `shared.ts`'s header.
 */

function* fetchCustomerCoupon(actions: any): Generator<any, void, any> {
  let url = ENDPOINT.LOYALTY.customerCoupon();
  try {
    let data = actions.payload;
    let dataToSend = {
      url: url,
      method: "POST",
      data: JSON.stringify(data.postBody),
    };
    let response = yield commonPostData(dataToSend);
    if (response?.errorCode) {
      notifyError(response?.errorCode);
    }
    if (response && !response?.errorCode) {
      data.callback?.(response);
    } else {
      yield put(redeemPointsSuccess(response));
      data.callback?.(response);
    }
  } catch (e) {
    yield put(
      redeemPointsSuccess({
        code: "Something went wrong. Please try again later",
        status: false,
      }),
    );
    console.log("check data ", e);
    actions.payload?.callback?.({
      code: "Something went wrong. Please try again later",
      status: false,
    });
  }
}

export default function* root() {
  yield takeEvery(getLoyaltyProviders.type, getLoyaltyProvidersData);
  yield takeEvery(getLoyaltyDetails.type, getLoyaltyDetailsData);
  yield takeEvery(redeemPoints.type, updateRedeemPointsData);
  yield takeEvery(verifyLoyaltyOtp.type, verifyOtpData);
  yield takeEvery(refundLoyaltyPoints.type, refundPoints);
  yield takeEvery(externalOfferVerify.type, verifyExternalOffer);
  yield takeEvery(customerOfferList.type, fetchCustomerCoupon);
  yield takeEvery(unBlockExternalDiscount.type, unblockExternalPartnerDiscount);
  yield takeEvery(verifyCustomerConsentOtp.type, verifyCustomerConsentOtpSaga);
  yield takeEvery(sendCustomerConsentOtp.type, sendCustomerConsentOtpSaga);
  yield takeEvery(customerOptOut.type, customerOptOutSaga);
  yield takeEvery(getProgramDetails.type, fetchProgramDetails);
}
